import { createContext } from 'react';
import { observable } from 'mobx';

const BookingStore = observable({
  isLoading: true,
  isLoadingFilter: false,
  idVehicleFilter: undefined,
  bookings: [],
  vehicles: [],
  allVehicles: [],
  drivers: [],
  idDriverFilter: undefined,
});

BookingStore.setValue = function(name, value) {
  this[name] = value;
};

const BookingStoreContext = createContext(BookingStore);

export default BookingStoreContext;
